export function getCountryOptions() {
  return [
    { text: 'Brasil', value: 'br', 'data-value': 'br' },
    { text: 'United States', value: 'us', 'data-value': 'us' },
  ];
}
